import base from './base.js'

class PortalService {

  constructor () {
    this.loadCategories = this.loadCategories.bind(this)
    this.loadOverviewData = this.loadOverviewData.bind(this)
  }

  loadCategories(successCallback, failCallback) {
    base.verifiedRequest({
      path: '/api/portal/v1/category/list',
      method: 'GET',
      data: {},
      success: function (res) {
        successCallback && successCallback(res)
      },
      fail: function (msg) {
        if (failCallback) {
          failCallback(msg)
        } else {
          alert(msg)
        }
      }
    })
  }

  loadOverviewData(successCallback, failCallback) {
    base.verifiedRequest({
      path: '/api/portal/v1/overview/stats',
      method: 'GET',
      data: {},
      success: function (res) {
        successCallback && successCallback(res)
      },
      fail: function (msg) {
        if (failCallback) {
          failCallback(msg)
        } else {
          alert(msg)
        }
      }
    })
  }
}

export default {
  PortalService: PortalService
}



// WEBPACK FOOTER //
// ./src/service/portal.js